import * as z from "zod";

const req = (msg: string) =>
  z.preprocess((v) => (v == null ? "" : v), z.string().trim().min(1, msg));

export const ContactFormSchema = z.object({
  // Primary Contact Information
  first_name: req("Please enter first name."),
  last_name: req("Please enter last name."),
  corporate_email: z.preprocess(
    (v) => (v == null ? "" : v),
    z
      .string()
      .trim()
      .min(1, "Please enter corporate email.")
      .email("Enter a valid email.")
  ),
  designation: req("Please enter designation."),
  job_title: req("Please enter position."),
  mobile_phone: z.preprocess(
    (v) => (v == null ? "" : v),
    z.string().trim().min(1, "Please enter mobile number.")
  ),
  work_phone_no: z.string().optional(),
  street_address: z.string().optional(),
  country_id: z.preprocess(
    (v) => (v == null ? 0 : Number(v)),
    z.number().min(1, "Please select country.")
  ),
  state_id: z.preprocess(
    (v) => (v == null ? 0 : Number(v)),
    z.number().min(1, "Please select state.")
  ),
  city_id: z.preprocess(
    (v) => (v == null ? 0 : Number(v)),
    z.number().min(1, "Please select city.")
  ),
  postal_code: z
    .preprocess((v) => (v == null ? "" : v), z.string().trim())
    .optional(),

});

export type ContactFormValues = z.infer<typeof ContactFormSchema>;
